import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QUOTE_CARDS } from '../../../Data/testimonials.data';

@Component({
  selector: 'app-working',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './working.html',
  styleUrls: ['./working.css'],
})
export class Working {
  readonly orbitPeople = [
    { image: 'images/common/client4.png', className: 'person p1' },
    { image: 'images/common/client1.png', className: 'person p2' },
    { image: 'images/common/client7.png', className: 'person p3' },
    { image: 'images/common/client2.png', className: 'person p4' },
    { image: 'images/common/client9.png', className: 'person p5' },
    { image: 'images/common/client3.png', className: 'person p6' },
    { image: 'images/common/client11.png', className: 'person p7' },
    { image: 'images/common/client6.png', className: 'person p8' },
    { image: 'images/common/client5.png', className: 'person p9' },
    { image: 'images/common/client10.png', className: 'person p10' },
    { image: 'images/common/client8.png', className: 'person p11' },
  ];

  readonly quoteCards = QUOTE_CARDS;
}